/**
 * Template: Cart
 * ------------------------------------------------------------------------------
 * Loosely coupled cart page scripts.
 *
 * @namespace cart
 */
import * as cart from '@shopify/theme-cart';

import axios from 'axios';
import CartTable from '../components/cart-table';
import CartAddOn from '../components/cart-add-on';
import cssClasses from '../helpers/cssClasses';
import NostoSlider from '../components/nosto-slider';
import QuickView from '../components/quick-view';
import CartDcode from '../components/cart-dcode';
import {on} from '../helpers/utils';
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-cart="container"]',
  table: '[js-cart-table="container"]',
  panel: '[js-cart="panel"]',
  checkout: '[js-cart="checkout"]',
  freeGift: '[js-cart="freeGift"]',
};

/**
 * DOM node selectors.
 */
const nodeSelectors = {
  panel: document.querySelector(selectors.panel),
  container: document.querySelector(selectors.container),
  checkout: document.querySelector(selectors.checkout),
  freeGift: document.querySelector(selectors.freeGift),
};

/**
 * Global instance strings.
 */
const strings = {
  title: theme.strings.cart.general.title,
  empty: theme.strings.cart.general.empty,
  continueBrowsing: theme.strings.cart.general.continue_browsing,
};

document.addEventListener('DOMContentLoaded', () => {
  if (!nodeSelectors.panel) {
    return;
  }

  CartTable(selectors.table).init();

  Frame.EventBus.listen('FreeGift:redeemed', () => {
    nodeSelectors.freeGift.classList.add(cssClasses.hidden);
  });

  Frame.EventBus.listen('FreeGift:lost', () => {
    nodeSelectors.freeGift.classList.remove(cssClasses.hidden);
  });

  Frame.EventBus.listen('AjaxCart:cartEmpty', () => {
    cart.clearItems()
      .then(() => cart.clearNote())
      .then(() => {
        nodeSelectors.container.innerHTML = `
          <div class="container">
            <div class="row">
              <div class="col xs12 m6 offset-m3 text-center">
                <h1>${strings.title}</h1>
                <p>${strings.empty}</p>
                <a href="/collections/all" class="button button--primary button--large">${strings.continueBrowsing}</a>
              </div>
            </div>
          </div>
        `;
      })
      .catch(() => {
        window.location.reload();
        throw new Error('Could not clear cart');
      });
  });

  Frame.EventBus.listen('Cart:updatingPrices', () => {
    nodeSelectors.panel.classList.add(cssClasses.loading);
  });

  Frame.EventBus.listen('Cart:pricesUpdated', () => {
    nodeSelectors.panel.classList.remove(cssClasses.loading);
  });

  NostoSlider().init();

  CartDcode().init();

  if (theme.features.cartAddOn) {
    CartAddOn().init();
  }

  if (theme.features.quickview) {
    QuickView().init();
  }

  /**
   * Check if checkout button has been clicked
   */
  function setEventEmit() {
    on('click', nodeSelectors.checkout, (event) => checkoutInitiated(event));
  }

  /**
   * Use the EventBus to emit checkout button being clicked with response from cart
   */
  function checkoutInitiated() {
    axios.get('/cart.js')
      .then((response) => {
        Frame.EventBus.emit('Cart:checkoutClicked', (response));
      })
      .catch((error) => {
        return error;
      });
  }

  setEventEmit().init();
});
